import { render, staticRenderFns } from "./AddIntegration.vue?vue&type=template&id=22a70ee8&scoped=true&"
import script from "./AddIntegration.vue?vue&type=script&lang=js&"
export * from "./AddIntegration.vue?vue&type=script&lang=js&"
import style0 from "./AddIntegration.vue?vue&type=style&index=0&id=22a70ee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a70ee8",
  null
  
)

export default component.exports